import { FormButtonsLayout } from 'framework/ui/layout';
import { useEffect, useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';
import { useFormContext } from 'framework/form';
import { PROCESS_ASSETS_CTO, PROCESS_ASSETS_STATUS } from '../constants';
import { useAuthorization } from 'framework/authorization';
import { ProcessAssetsFormType } from '../types';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';

const ProcessAssetsFormButtons = ({
  isEditForm,
  publishView,
  onTogglePublishView,
  onCloseModal,
  onCancelPreview,
}: {
  isEditForm: boolean;
  publishView: boolean;
  onTogglePublishView: () => void;
  onCloseModal: () => void;
  onCancelPreview: () => void;
}) => {
  const { getUserAlias } = useAuthenticatedUserService();
  const { data, isSubmitEnabled, isLoadingArtifact, submitForm, onChangeCallback } = useFormContext();
  const [submitting, setSubmitting] = useState(false);
  const { isGranted } = useAuthorization();
  const currentUserAlias = useAsyncValue(async () => getUserAlias());
  const formData = data as ProcessAssetsFormType;

  useEffect(() => {
    if (submitting && submitForm) {
      submitForm();
      setSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitting]);

  const publishMethod = async () => {
    if (onChangeCallback) {
      onChangeCallback({ status: PROCESS_ASSETS_STATUS.PUBLISHED });
      setSubmitting(true);
    }
  };

  const accessPublish = isGranted([PROCESS_ASSETS_CTO]) || formData.owner === currentUserAlias;

  if (isEditForm) {
    return <FormButtonsLayout submitButtonText="Save" onCancelAction={onCloseModal} />;
  }

  if (publishView) {
    return (
      <Box display="flex">
        {accessPublish && (
          <Button
            color="secondary"
            onClick={publishMethod}
            disabled={!isSubmitEnabled || isLoadingArtifact}
            sx={{ mr: '10px' }}
          >
            Publish
          </Button>
        )}

        <FormButtonsLayout submitButtonText="Upload" onCancelAction={onCancelPreview} />
      </Box>
    );
  }

  return (
    <Box>
      <Button
        data-testid="submit-button"
        onClick={onTogglePublishView}
        disabled={!isSubmitEnabled || isLoadingArtifact}
        sx={{
          marginRight: '10px',
        }}
      >
        Continue
      </Button>
      <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCloseModal}>
        Cancel
      </Button>
    </Box>
  );
};

export default ProcessAssetsFormButtons;
